import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/mockjs/mock.ts'
/* ui */
import { ElCarousel, ElCarouselItem, ElTable, ElTableColumn } from 'element-plus'

const app = createApp(App)
app.use(ElCarousel)
app.use(ElCarouselItem)
app.use(ElTable)
app.use(ElTableColumn)
app.use(store).use(router).mount('#app')
